import React from 'react';
import { Drawer as AntDrawer } from 'antd';
import type { DrawerProps } from 'antd';
import {
  DRAWER_DEFAULT_WIDTH,
  DRAWER_LARGE_WIDTH,
  scaleDrawerDimension,
} from '../design/drawerSizes';

function resolveScaledDrawerProps(
  props: DrawerProps,
): Pick<DrawerProps, 'size' | 'width' | 'height' | 'defaultSize'> {
  const { size, width, height, placement = 'right' } = props;
  const isHorizontal = placement === 'left' || placement === 'right';

  if (typeof size === 'number') {
    return { size: scaleDrawerDimension(size) };
  }

  if (size === 'large') {
    return { size: DRAWER_LARGE_WIDTH };
  }

  if (size === 'default') {
    return { size: DRAWER_DEFAULT_WIDTH };
  }

  if (typeof size === 'string' && /^\d+(\.\d+)?$/.test(size)) {
    return { size: scaleDrawerDimension(Number(size)) };
  }

  if (isHorizontal) {
    if (width !== undefined) {
      return { width: scaleDrawerDimension(Number(width)) };
    }

    return { defaultSize: DRAWER_DEFAULT_WIDTH };
  }

  if (height !== undefined) {
    return { height: scaleDrawerDimension(Number(height)) };
  }

  return { defaultSize: DRAWER_DEFAULT_WIDTH };
}

const AppDrawer: React.FC<DrawerProps> = (props) => {
  const scaledProps = resolveScaledDrawerProps(props);
  return <AntDrawer {...props} {...scaledProps} />;
};

export default AppDrawer;
export type { DrawerProps };
